var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { autocomplete: "off" },
      model: {
        value: _vm.formValid,
        callback: function($$v) {
          _vm.formValid = $$v
        },
        expression: "formValid"
      }
    },
    [
      _c(
        "div",
        { attrs: { id: "pripad-sumar" } },
        [
          _c(
            "div",
            { staticClass: "pripad-sumar-header" },
            [
              _c(
                "v-container",
                { staticClass: "pa-0", class: { "pt-7": !_vm.isMobile } },
                [
                  !_vm.isMobile
                    ? _c("h1", { staticClass: "left mb-4 mt-20px" }, [
                        _vm._v("Sumár ponuky - " + _vm._s(_vm.pripad.cislo))
                      ])
                    : _c("h2", { staticClass: "left mx-4 my-4" }, [
                        _vm._v("Sumár ponuky - " + _vm._s(_vm.pripad.cislo))
                      ]),
                  !_vm.isMobile
                    ? _c("Status", {
                        staticClass: "mt-8 ml-4",
                        attrs: { state: _vm.pripad.idStavu }
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "nofloat" },
                    [
                      _vm.jeDealer
                        ? [
                            _c("text-group", {
                              staticClass: "left",
                              class: {
                                "mr-10": !_vm.isMobile,
                                "ml-4 mb-4": _vm.isMobile
                              },
                              attrs: {
                                gap: 5,
                                utext: "Vytvorené dňa",
                                btext: _vm.datumVzniku
                              }
                            }),
                            !_vm.isMobile
                              ? _c("text-group", {
                                  attrs: {
                                    utext: "Vytvoril",
                                    gap: 5,
                                    btext: _vm.pripad.vytvoril
                                  }
                                })
                              : _vm._e()
                          ]
                        : [
                            _c("text-group", {
                              class: { "ml-4 mb-4": _vm.isMobile },
                              attrs: {
                                gap: 5,
                                utext: "Vytvorené dňa",
                                btext: _vm.datumVzniku
                              }
                            })
                          ]
                    ],
                    2
                  ),
                  _vm.jePrihlaseny
                    ? _c(
                        "v-tabs",
                        {
                          key: _vm.mainTabStep,
                          staticClass: "sumar-tabs",
                          class: {
                            "mt-23px": !_vm.isMobile,
                            "nofloat ml-4": _vm.isMobile
                          },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c("v-tab", [_vm._v("Predmety")]),
                          _vm.showNajomcaTab
                            ? _c(
                                "v-tab",
                                {
                                  class: {
                                    "ml-40px": !_vm.isMobile,
                                    "ml-6": _vm.isMobile
                                  }
                                },
                                [_vm._v("Žiadateľ")]
                              )
                            : _vm._e(),
                          _vm.showDodatInfo
                            ? _c(
                                "v-tab",
                                {
                                  class: {
                                    "ml-40px": !_vm.isMobile,
                                    "ml-6": _vm.isMobile
                                  }
                                },
                                [_vm._v("Dodatočné informácie")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-container",
            { staticClass: "pa-0" },
            [
              _c(
                "v-tabs-items",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.predmetyLoaded,
                      expression: "predmetyLoaded"
                    }
                  ],
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "div",
                        { class: { "d-flex flex-column": _vm.isMobile } },
                        [
                          _vm.getMenuItem("add_predmet").is_visible
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "btn-secondary",
                                  class: {
                                    "my-24px": !_vm.isMobile,
                                    "mx-4 mt-4": _vm.isMobile
                                  },
                                  attrs: {
                                    to:
                                      "/obchodny-pripad/" +
                                      _vm.pripad.newId +
                                      "?cislo_predmetu=" +
                                      _vm.novyPredmet +
                                      "&redirect=2",
                                    disabled:
                                      !_vm.getMenuItem("add_predmet")
                                        .is_enabled === 0 ||
                                      _vm.pripad == null ||
                                      _vm.pripad.newId == null
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getMenuItem("add_predmet")
                                        .display_member
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.getMenuItem("dokumenty").is_visible
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "btn-secondary",
                                  class: {
                                    "my-24px ml-16px": !_vm.isMobile,
                                    "mx-4 mt-4": _vm.isMobile
                                  },
                                  attrs: {
                                    disabled:
                                      _vm.getMenuItem("dokumenty") === 0 ||
                                      _vm.pripad == null ||
                                      _vm.pripad.newId == null
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.redirectToUploadDokumentov(
                                        _vm.pripad.newId,
                                        "0",
                                        "",
                                        "sumar-predmet"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getMenuItem("dokumenty")
                                        .display_member
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.getMenuItem("tlacit_pripad").is_visible
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "btn-secondary",
                                  class: {
                                    "my-24px ml-16px": !_vm.isMobile,
                                    "mx-4 mt-4": _vm.isMobile
                                  },
                                  attrs: {
                                    to:
                                      "/tlacdokumentov?newid=" +
                                      _vm.pripad.newId,
                                    disabled:
                                      _vm.getMenuItem("tlacit_pripad") === 0 ||
                                      _vm.pripad == null ||
                                      _vm.pripad.newId == null
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getMenuItem("tlacit_pripad")
                                        .display_member
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._l(_vm.predmety, function(item, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c("pripady-wizard-sumar-predmet", {
                              ref: "predmet" + index,
                              refInFor: true,
                              class: { "mb-24px": !_vm.isMobile },
                              attrs: {
                                predmet: item,
                                pravoNaAdresnuPonuku: _vm.pravoNaAdresnuPonuku,
                                show: _vm.showPredmet == index,
                                formaPodnikania: _vm.formaPodnikania
                              },
                              on: {
                                forceReload: _vm.reload,
                                loaded: function() {
                                  return _vm.checkPredmetyLoaded()
                                },
                                setShowPredmet: function(val) {
                                  return _vm.setShowPredmet(val, index)
                                },
                                changeVariant: function($event) {
                                  return _vm.onChangeVariant()
                                },
                                odoslatPonuku: function(varianty) {
                                  return _vm.odoslatPonuku(varianty)
                                },
                                reloadSpoludlznik:
                                  _vm.onReloadSpoludlznikDodatInfo,
                                odoslanieEmailuSpoludlznika:
                                  _vm.kontrolaPovinnostiSpoludlznika
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  _vm.showNajomcaTab
                    ? _c(
                        "v-tab-item",
                        [
                          _c("pripady-wizard-sumar-najomca", {
                            ref: "najomca",
                            attrs: {
                              menu: _vm.menu,
                              pravoNaAdresnuPonuku: _vm.pravoNaAdresnuPonuku,
                              formaPodnikania: _vm.formaPodnikania
                            },
                            on: { odoslatNaSchvalenie: _vm.odoslatNaSchvalenie }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showDodatInfo
                    ? _c(
                        "v-tab-item",
                        { attrs: { eager: this.selectedVarianty.length > 0 } },
                        [
                          _c("pripady-wizard-sumar-dodatocne-info", {
                            ref: "dodatInfo",
                            attrs: {
                              menu: _vm.menu,
                              pravoNaAdresnuPonuku: _vm.pravoNaAdresnuPonuku,
                              formaPodnikania: _vm.formaPodnikania,
                              variant: _vm.selectedVarianty[0]
                            },
                            on: {
                              setCustomButton: _vm.setCustomButton,
                              sumarChangeTab: function(val) {
                                return _vm.changeTab(val)
                              },
                              reloadSpoludlznik: _vm.onReloadSpoludlznikPredmet,
                              setValid: function(val) {
                                return _vm.setValid(
                                  val.value,
                                  val.property,
                                  val.message,
                                  val.showProgress,
                                  val.isError
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("kontrola-pred-schvalenim", {
        ref: "kontrolaPredSchvalenim",
        attrs: {
          cisloObchPripadu: _vm.pripad.cislo,
          cisloPredmetu: _vm.pripad.cisloPredmetu,
          formaPodnikania: _vm.formaPodnikania,
          newId: _vm.pripad.newId,
          isNeadresnaPonuka: _vm.isNeadresnaPonuka
        },
        on: {
          sumarChangeTab: function(val) {
            return _vm.changeTab(val)
          },
          openDodavatelInfoDialog: function(val) {
            return _vm.openDodavatelInfoDialog(val)
          },
          updateZmenaDodavatela: function(val) {
            return _vm.updateZmenaDodavatela(val)
          },
          setValid: function(val) {
            return _vm.setValid(
              val.value,
              val.property,
              val.message,
              val.showProgress,
              val.isError
            )
          }
        }
      }),
      _c(
        "v-dialog",
        {
          attrs: {
            value: _vm.doplnenieUdajovDialog,
            "overlay-color": "#000",
            "overlay-opacity": "0.66",
            persistent: true,
            width: "500"
          }
        },
        [
          _vm.doplnenieUdajovDialog
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "d-flex justify-space-between" },
                    [
                      _c("span", { staticClass: "f16" }, [
                        _vm._v(" Odoslať na schválenie")
                      ]),
                      _c(
                        "v-icon",
                        {
                          staticStyle: { "margin-left": "auto" },
                          on: {
                            click: function($event) {
                              _vm.doplnenieUdajovDialog = false
                            }
                          }
                        },
                        [_vm._v("mdi-close")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "pb-3" },
                    [
                      _c(
                        "v-form",
                        { ref: "doplnujuceInfoDodavatelForm" },
                        [
                          _c("span", { staticClass: "gs100 f16" }, [
                            _vm._v(
                              " Doplňte, prosím, informácie o dodávateľovi financovaného predmetu. "
                            )
                          ]),
                          _vm._l(_vm.doplnenieUdajov, function(udaje, index) {
                            return [
                              _c("v-divider", {
                                key: "divider" + udaje.cislo_predmetu,
                                staticClass: "my-3"
                              }),
                              _c(
                                "v-row",
                                { key: udaje.cislo_predmetu },
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "span",
                                      { staticClass: "white100 f18" },
                                      [_vm._v(_vm._s(udaje.nazov))]
                                    ),
                                    _c("br"),
                                    _c("span", { staticClass: "gs100 f12" }, [
                                      _vm._v(_vm._s(udaje.poznamka))
                                    ])
                                  ]),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "py-1",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c("zakaznik-combo", {
                                        ref: "zakaznik-" + index,
                                        refInFor: true,
                                        attrs: {
                                          isKlient: !_vm.jeDealer,
                                          rules: [_vm.rules.required]
                                        },
                                        on: {
                                          updateValue: function(val) {
                                            return (udaje.zakaznikUdaje = val)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "py-1",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      !_vm.jeDealer
                                        ? _c("text-box", {
                                            attrs: {
                                              rules: [
                                                _vm.rules.required,
                                                _vm.rules.telefonneCisloRule
                                              ],
                                              placeholder: "+421",
                                              label: "Tel. číslo",
                                              required: "",
                                              textOnFocus: "+421",
                                              removeCharacters: /[^+\d]/g,
                                              isPhoneNumber: true,
                                              cache: false
                                            },
                                            on: {
                                              input: function(val) {
                                                return (udaje.telCislo = val)
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-primary",
                          attrs: { variant: "elevated", density: "default" },
                          on: { click: _vm.doplnUdajeZakaznika }
                        },
                        [_vm._v(" Odoslať ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            value: _vm.schvalenieDialogDealer,
            "overlay-color": "#000",
            "overlay-opacity": "0.66",
            persistent: true,
            width: "500"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-center" }, [
                _c(
                  "div",
                  { staticClass: "w100" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "success600 primary500",
                        attrs: { size: 32 }
                      },
                      [_vm._v(" done ")]
                    )
                  ],
                  1
                )
              ]),
              _c("v-card-text", [
                _c(
                  "div",
                  { staticClass: "white100 bold f16 text-center mb-15px" },
                  [_vm._v(" " + _vm._s("Kontrola prebehla úspešne!") + " ")]
                ),
                _c("div", { staticClass: "white500 f16 text-center" }, [
                  _vm._v("Ponuka bola odoslaná na schválenie.")
                ])
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-5 bold gs100",
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          _vm.schvalenieDialogDealer = false
                        }
                      }
                    },
                    [_vm._v(" Zavrieť ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }